module.exports = __webpack_public_path__ + "static/media/body-bg-1.d10838d7.jpg";